import { render, staticRenderFns } from "./SelectOption.vue?vue&type=template&id=05ac3677&scoped=true&"
import script from "./SelectOption.vue?vue&type=script&lang=js&"
export * from "./SelectOption.vue?vue&type=script&lang=js&"
import style0 from "./SelectOption.vue?vue&type=style&index=0&id=05ac3677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac3677",
  null
  
)

export default component.exports